export default __webpack_public_path__ + "static/05-874742d2ea87f059b8435444c27a29f0.png";